<template>
  <exercise-logic
    exCollection="swotExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="true"
  >
    <template slot-scope="{ saveExercise }">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <template v-for="tab in tabs">
            <v-stepper-step
              :key="`tab${tab.count}`"
              color="amber"
              :complete="e1 > tab.count"
              :step="tab.count"
              @click="el = tab.count"
              >{{tab.title}}</v-stepper-step
            >
            <v-divider :key="`divider${tab.count}`"></v-divider>
          </template>
        </v-stepper-header>
        
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline" v-text="$t('exercise_swot.step1.title')"></h2>
              </v-col>
              <v-col cols="8" lg="6"  class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_swot.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
          </v-row>
            <v-row v-if="doc">
                <v-col cols="10">
                 <proposition-area
                  v-model="doc.strengths"
                  title="Strengths"
                  subtitle="What are you good at?"
                  color="blue"
                  :fullHeight="true"
                />
              </v-col>
            </v-row>
            <bottom-navigation
              :save="false"
              :next="true"
              :prev="true"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </v-stepper-content>
          <v-stepper-content step="2">
             <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline" v-text="$t('exercise_swot.step1.title')"></h2>
              </v-col>
              <v-col cols="8" lg="6"  class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_swot.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
          </v-row>
            <v-row v-if="doc">
                <v-col cols="10">
                <proposition-area
                  v-model="doc.weaknesses"
                  title="Weaknesses"
                  subtitle="What could you be better at?"
                  color="deep-orange"
                  :fullHeight="true"
                />
              </v-col>
            </v-row>
            <bottom-navigation
              :save="false"
              :next="true"
              :prev="true"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </v-stepper-content>
          <v-stepper-content step="3">
             <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline" v-text="$t('exercise_swot.step1.title')"></h2>
              </v-col>
              <v-col cols="8" lg="6"  class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_swot.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
          </v-row>
            <v-row v-if="doc">
              <v-col cols="10">
                <proposition-area
                  v-model="doc.opportunities"
                  title="Opportunities"
                  subtitle="What are your opportunities?"
                  color="green"
                  :fullHeight="true"
                />
                
              </v-col>
            </v-row>
            <bottom-navigation
              :save="false"
              :next="true"
              :prev="true"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </v-stepper-content>
          <v-stepper-content step="4">
             <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline" v-text="$t('exercise_swot.step1.title')"></h2>
              </v-col>
              <v-col cols="8" lg="6"  class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_swot.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
          </v-row>
            <v-row v-if="doc">
              <v-col cols="10">
                <proposition-area
                  v-model="doc.threats"
                  title="Threats"
                  subtitle="What could threaten your position?"
                  color="pink"
                  :fullHeight="true"
                />
              </v-col>
            </v-row>
            <bottom-navigation
              :save="false"
              :next="true"
              :prev="true"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="saveExercise(false)"
            >
            </bottom-navigation>
          </v-stepper-content>
          <v-stepper-content step="5">
             <v-row>
              <v-col cols="4" class="mb-4">
                <h2 class="headline" v-text="$t('exercise_swot.step1.title')"></h2>
              </v-col>
              <v-col cols="8" lg="6"  class="mb-4">
                <p
                  v-for="(item, index) in $t(
                    'exercise_swot.step1.description'
                  )"
                  :key="index"
                  v-text="item"
                />
              </v-col>
          </v-row>
            <v-row v-if="doc">
              <v-col cols="6">
                <proposition-area
                  v-model="doc.strengths"
                  title="Strengths"
                  subtitle="What are you good at?"
                  color="blue"
                />
              </v-col>
               <v-col cols="6">
                <proposition-area
                  v-model="doc.weaknesses"
                  title="Weaknesses"
                  subtitle="What could you be better at?"
                  color="deep-orange"
                />
              </v-col>
              <v-col cols="6">
                <proposition-area
                  v-model="doc.opportunities"
                  title="Opportunities"
                  subtitle="What are your oppotunities?"
                  color="green"
                />
              </v-col>
              <v-col cols="6">
                <proposition-area
                  v-model="doc.threats"
                  title="Threats"
                  subtitle="What could threaten your position?"
                  color="pink"
                />
              </v-col>
            </v-row>

             <v-row v-if="doc" class="mt-10">
              <v-col cols="3">
                <h2 class="headline blue--text">Strengths</h2>
                <ul class="list--none">
                  <li v-for="(item, index) in doc.strengths" :key="`strengths-${index}`">{{item}}</li>
                </ul>

              </v-col>
              <v-col cols="3">
                <h2 class="headline deep-orange--text">Weaknesses</h2>
                <ul class="list--none">
                  <li v-for="(item, index) in doc.weaknesses" :key="`strengths-${index}`">{{item}}</li>
                </ul>
              </v-col>
              <v-col cols="3">
                <h2 class="headline green--text">Opportunities</h2>
                <ul class="list--none">
                  <li v-for="(item, index) in doc.opportunities" :key="`strengths-${index}`">{{item}}</li>
                </ul>
              </v-col>
               <v-col cols="3">
                <h2 class="headline pink--text">Threats</h2>
                <ul class="list--none">
                  <li v-for="(item, index) in doc.threats" :key="`strengths-${index}`">{{item}}</li>
                </ul>
              </v-col>
            </v-row>

            <bottom-navigation
              :save="true"
              :next="false"
              :prev="true"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise"
              @prev="prevStep"
              @next="nextStep"
            >
            </bottom-navigation>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { PropositionArea } from "./proposition";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTov",
  data() {
    return {
      e1: 1,
      doc: {
        strengths: [],
        weaknesses: [],
        opportunities: [],
        threats: [],
      },
      tabs: [
        {title: 'Strengths', count: 1},
        {title: 'Weaknesses', count: 2},
        {title: 'Opportunities', count: 3},
        {title: 'Threats', count: 4},
        {title: 'Summary', count: 5},
      ],
      userSelected: null,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    PropositionArea,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
    }
  },
};
</script>

<style lang="scss"></style>
